import Vue from 'vue'
import Router from 'vue-router'
import getFormatById from '@/assets/formats/get-format-by-id'
/* トップ以外は非同期読み込み */
import formatList from '@/views/FormatList'
Vue.use(Router)

const SITE_TITLE = process.env.VUE_APP_SITE_TITLE
const NOT_FOUND_PATH = '/404'

const previewProps = function (route) {
  return {
    preview: true,
    formatId: route.params.formatId,
    cardId: route.params.cardId
  }
}

const getCardTitle = function (cards, cardId) {
  const result = cards.find(function (card) {
    return card.id === cardId
  })
  if (result) return result.title
}

const getFormatMeta = function (formatId, cardId) {
  const result = getFormatById(formatId)
  if (result) {
    return {
      title: result.title,
      description: result.description,
      cardTitle: getCardTitle(result.cards, cardId)
    }
  }
}

/*
** SEO用 title、meta descriptionを作成
*/
const setFormatMeta = function (to) {
  let formatMeta = getFormatMeta(to.params.formatId, to.params.cardId)
  if (!formatMeta) {
    console.error('format meta not set.')
    return
  }
  if (formatMeta.cardTitle) {
    document.title = `${formatMeta.cardTitle} - ${formatMeta.title} - ${to.meta.title}`
    metaDescriptionElement.content = `${formatMeta.title}の${formatMeta.cardTitle}のページです。${formatMeta.description}`
  } else {
    document.title = `${formatMeta.title}  - ${to.meta.title}`
    metaDescriptionElement.content = formatMeta.description
  }
  console.log(to)
  if (to.meta.linkformat == 1) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}`
  } else if (to.meta.linkformat == 2) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}`
  } else if (to.meta.linkformat == 3) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit`
  } else if (to.meta.linkformat == 4) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}`
  } else if (to.meta.linkformat == 5) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}/preview`
  } else if (to.meta.linkformat == 6) {
    headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/${to.path}`
  }
}

const formatExistsOr404 = function (to, from, next) {
  if (!to.params.formatId) {
    next({ name: 'notFound' })
    return
  }
  const id = to.params.formatId
  const formatResult = getFormatById(id)
  if (!formatResult) {
    next({ name: 'notFound' })
    return
  }
  if (!to.params.cardId) {
    next()
    return
  }
  const cardId = to.params.cardId
  const cardResult = formatResult.cards.find(function (card) { return card.id === cardId })
  if (!cardResult) {
    next({ name: 'notFound' })
    return
  }
  next()
}

const routes = [
  {
    path: '/',
    component: formatList,
    name: 'top',
    meta: {
      title: SITE_TITLE,
      linkformat: 1
    }
  },
  {
    path: '/format/:formatId',
    component: () => import('@/views/FormatDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'formatDetail',
    meta: {
      title: `テンプレート - ${SITE_TITLE}`,
      linkformat: 2
    }
  },
  {
    path: '/format/:formatId/edit',
    component: () => import('@/views/FormatEdit'),
    props: true,
    name: 'formatEdit',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `編集 - ${SITE_TITLE}`,
      linkformat: 3
    }
  },
  {
    path: '/format/:formatId/edit/:cardId',
    component: () => import('@/views/FormatEdit'),
    props: true,
    name: 'formatEditCard',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `編集 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/format/:formatId/edit/:cardId/preview',
    component: () => import('@/views/FormatEdit'),
    props: previewProps,
    name: 'formatPreview',
    beforeEnter: formatExistsOr404,
    meta: {
      title: `プレビュー - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/recomm/:secureId/:secureKey',
    component: () => import('@/views/pages/Introduction'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `紹介・推薦入力ページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の紹介・推薦入力ページです`,
      linkformat: 6
    }
  },
  {
    path: '/recomm/:secureId',
    component: () => import('@/views/pages/Introduction'),
    props: true,
    name: 'IntroductionPage',
    meta: {
      title: `紹介・推薦入力ページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の紹介・推薦入力ページです`,
      linkformat: 6
    }
  },
  {
    path: '/recomm_preview/:accessId',
    component: () => import('@/views/IntroductionPreview'),
    props: true,
    name: 'IntroductionPreviewPage',
    meta: {
      title: `紹介・推薦プレビュー - ${SITE_TITLE}`,
      linkformat: 5
    }
  },
  {
    path: '/athlete/:formatId/:univId',
    component: () => import('@/views/FormatDetail'),
    props: true,
    beforeEnter: formatExistsOr404,
    name: 'formatDetail',
    meta: {
      title: `テンプレート - ${SITE_TITLE}`,
      linkformat: 2
    }
  },
  {
    path: '/help',
    component: () => import('@/views/pages/Help'),
    name: 'helpPage',
    meta: {
      title: `ヘルプ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のヘルプページです`,
      linkformat: 6
    }
  },
  {
    path: '/download',
    component: () => import('@/views/pages/Download'),
    name: 'downloadPage',
    meta: {
      title: `ダウンロード - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のダウンロードページです`,
      linkformat: 6
    }
  },
  {
    path: '/bokumetsu',
    component: () => import('@/views/pages/Bokumetsu'),
    name: 'bokumetsuPage',
    meta: {
      title: `手書き履歴書撲滅キャンペーン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の手書き履歴書撲滅キャンペーンページです`,
      linkformat: 6
    }
  },
  {
    path: '/cvtest',
    component: () => import('@/views/pages/CvTest'),
    name: 'cvtest',
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/terms',
    component: () => import('@/views/pages/Terms'),
    name: 'termsPage',
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/tempterms',
    component: () => import('@/views/pages/Terms_copy'),
    name: 'termsPage',
    meta: {
      title: `利用規約 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/quickmailterms',
    component: () => import('@/views/pages/QuickmailTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギの宅配便の利用規約 - ${SITE_TITLE}`,
      description: `ヤギの宅配便の利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/yagiofferterms',
    component: () => import('@/views/pages/YagiofferTerms'),
    name: 'termsPage',
    meta: {
      title: `ヤギオファーの利用規約 - ${SITE_TITLE}`,
      description: `ヤギオファーの利用規約です`,
      linkformat: 6
    }
  },
  {
    path: '/quickmailhelp',
    component: () => import('@/views/pages/QuickmailHelp'),
    name: 'termsPage',
    meta: {
      title: `ヤギの宅配便の利用方法 - ${SITE_TITLE}`,
      description: `ヤギの宅配便の利用方法説明ページです`,
      linkformat: 6
    }
  },
  {
    path: '/yagiofferhelp',
    component: () => import('@/views/pages/YagiofferHelp'),
    name: 'yagiofferHelpPage',
    meta: {
      title: `ヤギオファーの利用方法 - ${SITE_TITLE}`,
      description: `ヤギオファーの利用方法説明ページです`,
      linkformat: 6
    }
  },
  {
    path: '/privacy',
    component: () => import('@/views/pages/Privacy'),
    name: 'policyPage',
    meta: {
      title: `個人情報保護方針 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の個人情報保護方針です`,
      linkformat: 6
    }
  },
  {
    path: '/company',
    name: 'companyPage',
    beforeEnter() {
      window.location = "https://www.yagish.jp"
    }
    // component: () => import('@/views/pages/Company'),
    // name: 'companyPage',
    // meta: {
    //   title: `会社紹介 - ${SITE_TITLE}`,
    //   description: `${SITE_TITLE}の会社紹介です`,
    //   linkformat: 6
    // }
  },
  {
    path: '/checklist_jobchange/:formatId/:cardId',
    component: () => import('@/views/pages/Jobagree'),
    name: 'JobagreePage',
    meta: {
      title: `「転職活動チェックリスト」で準備、対策、進め方を把握しよう！ - ${SITE_TITLE}`,
      description: `転職活動はいざ始まると忙しくなるので、予めやることをチェックリストで把握しておくことが大切です。
      Yagish(ヤギッシュ)は「自己分析」「履歴書・職歴書の添削」「退職手続き」「自分に合った会社の選定」など効率の良い転職活動をサポートします。`,
      linkformat: 6
    }
  },
  // {
  //   path: '/quickmail/:cardId',
  //   component: () => import('@/views/QuickMailService'),
  //   props: true,
  //   name: 'quickmailCard',
  //   meta: {
  //     title: `ヤギの宅配便 - ${SITE_TITLE}`,
  //     linkformat: 4
  //   }
  // },
  {
    path: '/quickemail/:cardId',
    component: () => import('@/views/QuickEMailService'),
    props: true,
    name: 'quickemailCard',
    meta: {
      title: `ヤギのメール便 - ${SITE_TITLE}`,
      linkformat: 4
    }
  },
  {
    path: '/info',
    component: () => import('@/views/pages/ServiceInfo'),
    name: 'serviceInfoPage',
    meta: {
      title: `このサービスについて - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のサービスについて説明です`,
      linkformat: 6
    }
  },
  {
    path: '/mailmaga/:clientId',
    component: () => import('@/views/pages/Mailmaga'),
    name: 'mailMagaPage',
    props: true,
    meta: {
      title: `おすすめ情報 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}からあなたにおすすめ情報を紹介するページです`,
      linkformat: 6
    }
  },
  {
    path: '/login',
    component: () => import('@/views/pages/Login'),
    name: 'loginPage',
    meta: {
      title: `ログイン - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のログインページです`,
      linkformat: 6
    }
  },
  {
    path: '/mypage',
    component: () => import('@/views/pages/MyPage'),
    name: 'myPage',
    meta: {
      title: `マイページ - ${SITE_TITLE}`,
      description: `${SITE_TITLE}のマイページです`,
      linkformat: 6
    }
  },
  {
    path: '/infosave',
    component: () => import('@/views/pages/ServiceInfoSave'),
    name: 'serviceInfoSavePage',
    meta: {
      title: `入力した情報の保存ついて - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の入力した情報の保存について説明です`,
      linkformat: 6
    }
  },
  {
    path: '/postcard',
    component: () => import('@/views/YagiPostCard'),
    name: 'postCard',
    meta: {
      title: `ヤギにハガキを渡す - ${SITE_TITLE}`,
      description: `${SITE_TITLE}の運営元宛てのハガキをヤギに頼めます`,
      linkformat: 6
    }
  },
  {
    path: '/gacha',
    component: () => import('@/views/YagiGacha'),
    name: 'gacha',
    meta: {
      title: `ガチャ - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - ガチャ`,
      linkformat: 6
    }
  },
  {
    path: '/hiroba',
    component: () => import('@/views/YagiHiroba'),
    name: 'hiroba',
    meta: {
      title: `広場 - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - 広場`,
      linkformat: 6
    }
  },
  {
    path: '/account/delete',
    component: () => import('@/views/AccountDelete'),
    name: 'accountDelete',
    meta: {
      title: `データ・アカウントの削除 - ${SITE_TITLE}`,
      description: `${SITE_TITLE} - 広場`,
      linkformat: 6
    }
  },

  {
    path: NOT_FOUND_PATH,
    component: () => import('@/views/NotFound'),
    alias: ['/404.html'],
    name: 'notFound',
    meta: {
      title: `ページが見つかりません - ${SITE_TITLE}`,
      linkformat: 1
    }
  },
  {
    path: '*',
    redirect: { name: 'notFound' }
  }
]
if (process.env.VUE_APP_MODE === 'development') {
  routes.push({
    path: '/admin',
    component: () => import('@/views/AdminIndex'),
    name: 'adminIndex',
    meta: {
      title: `管理用 - ${SITE_TITLE}`,
      description: `${SITE_TITLE}で入力したデータのバックアップ作成やプレビュー、復元をすることができます。`
    }
  })
}
const router = new Router({
  mode: 'history',
  routes: routes,
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) return savedPosition
    // カード間の移動時は
    // 最上部へのスクロールを無視する
    if (to.name === 'formatEditCard' && from.name === 'formatEditCard') {
      return
    }
    return { x: 0, y: 0 }
  }
})

const metaDescriptionElement = document.getElementById('head-meta-description')
const headLinkCanonical = document.getElementById('head-link-canonical')
const defaultDescription = metaDescriptionElement.content
router.afterEach((to, from) => {
  if (to.params.formatId) {
    setFormatMeta(to)
  } else if (to.meta && to.meta.title) {
    document.title = to.meta.title
    if (to.meta.description) {
      metaDescriptionElement.content = to.meta.description
    } else {
      metaDescriptionElement.content = defaultDescription
    }
    if (to.meta.linkformat == 1) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}`
    } else if (to.meta.linkformat == 2) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}`
    } else if (to.meta.linkformat == 3) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit`
    } else if (to.meta.linkformat == 4) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}`
    } else if (to.meta.linkformat == 5) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}/format/${to.params.formatId}/edit/${to.params.cardId}/preview`
    } else if (to.meta.linkformat == 6) {
      headLinkCanonical.href = `${process.env.VUE_APP_SITE_URL}${to.path}`
    }
  }
})
export default router
